let Backbone = require("backbone");
let _ = require("underscore");

let main = function (Backbone, _) {
    return Backbone.Model.extend({
        defaults: {
            organization: {
                id: null
            },
            feature: {
                id: null,
                type: null,
                memo: null
            },
            startDate: null,
            endDate: null,
            purchaseAmount: null,
            purchasePolicyItem: {
                memo: null
            }
        }
    });
};

let exportedValue = main(Backbone, _);
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/model/settings/PurchaseHistoryModel.js